export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-619.000000, -19030.000000)">
                    <g id="编组-50" transform="translate(397.000000, 18175.000000)">
                        <g id="编组-14" transform="translate(28.000000, 802.000000)">
                            <g id="18button/无背景/content+icon" transform="translate(100.000000, 47.000000)">
                                <g id="功能图标/右滑" transform="translate(94.000000, 6.000000)">
                                    <rect id="矩形" x="0" y="0" width="16" height="16"></rect>
                                    <path
                                        d="M6.77385051,8 L10.9687789,12.233333 C11.1229243,12.3888896 11.2,12.5777768 11.2,12.8 C11.2,13.0222234 11.1229243,13.2111103 10.9687789,13.3666667 C10.8146335,13.522223 10.6274616,13.6 10.4072543,13.6 C10.187047,13.6 9.99987339,13.522223 9.84572859,13.3666667 L5.05624143,8.53333333 C4.70390957,8.17777615 4.71491978,7.81111284 5.08927237,7.43333181 L9.84572859,2.63333181 C9.99987339,2.47777524 10.187047,2.4 10.4072543,2.4 C10.6274616,2.4 10.8146335,2.47777524 10.9687789,2.63333181 C11.1229243,2.78888838 11.2,2.97777371 11.2,3.2 C11.2,3.42222629 11.1229243,3.61111162 10.9687789,3.76666819 L6.77385051,8 Z"
                                        id="Fill-1"
                                        fill="#2164FF"
                                        transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
